<section [ngClass]="dynamicClass">
  <!-- {{contactForm.value | json}} -->
  <div class="eq-container">
    <h2 class="eq-text-blue-darkBlue eq-text-heading2-m lg:eq-text-heading2">{{rendering.fields?.Title?.value}}</h2>
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="eq-contact-form eq-py-5 eq-flex eq-flex-col lg:eq-grid lg:eq-grid-cols-2 eq-gap-5 lg:eq-gap-x-10 lg:eq-gap-y-8">
      <div app-form-dropdown 
        formControlName="dropdown"
        [name]="'dropdown'"
        [id]="'dropdown'"
        [isRequired]="true"
        [labelText]="rendering.fields?.DropdownLabel?.value"
        [hasPlaceholder]="true"
        [placeholderLabel]="rendering.fields?.DropdownPlaceholder?.value"
        [options]="options"
        [error]="isFieldInvalid('dropdown') "
        [errorText]="rendering?.fields?.FieldIsRequiredError?.value"
        (valueChange)="onChange()"
        [sorting]="false"
        class="lg:eq-col-span-2 lg:eq-w-1/2 lg:eq-pr-[20px] xl:eq-pr-[30px]"
      >
      </div>
      <div 
        app-form-text-input
        formControlName="name"
        [name]="'name'"
        [id]="'name'"
        [labelText]="rendering.fields?.NameLabel?.value"
        [isRequired]="true"
        [error]="isFieldInvalid('name')"
        [errorText]="contactForm.get('name').errors?.minlength ? rendering?.fields?.Min3LengthError?.value : 
          contactForm.get('name').errors?.maxlength ? rendering?.fields?.MaxLengthError?.value : 
          contactForm.get('name').errors?.alphabeticOnly ? rendering?.fields?.OnlyAlphabeticError?.value : 
          rendering?.fields?.FieldIsRequiredError?.value"
        class="lg:eq-col-span-1"
      >
      </div>
      <div 
        app-form-text-input
        formControlName="surname"
        [name]="'surname'"
        [id]="'surname'"
        [labelText]="rendering.fields?.SurnameLabel?.value"
        [isRequired]="true"
        [error]="isFieldInvalid('surname')"
        [errorText]="contactForm.get('surname').errors?.minlength ? rendering?.fields?.Min3LengthError?.value : 
          contactForm.get('surname').errors?.maxlength ? rendering?.fields?.MaxLengthError?.value : 
          contactForm.get('surname').errors?.alphabeticOnly ? rendering?.fields?.OnlyAlphabeticError?.value : 
          rendering?.fields?.FieldIsRequiredError?.value"
        class="lg:eq-col-span-1"
      >
      </div>
      <div 
        app-form-text-input
        formControlName="companyName"
        [name]="'companyName'"
        [id]="'companyName'"
        [labelText]="rendering.fields?.CompanyNameLabel?.value"
        [isRequired]="contactForm.get('dropdown')?.value === '1'"
        [error]="isFieldInvalid('companyName')"
        [isDisabled]="this.contactForm.get('dropdown')?.value !== '1'"
        [errorText]="contactForm.get('companyName').errors?.alphabeticOnly ? rendering?.fields?.OnlyAlphabeticError?.value : 
        rendering?.fields?.FieldIsRequiredError?.value"
      >
      </div>
      <div
        app-form-text-input
        formControlName="position"
        [name]="'position'"
        [id]="'position'"
        [labelText]="rendering.fields?.PositionLabel?.value"
        [isRequired]="contactForm.get('dropdown')?.value === '1'"
        [error]="isFieldInvalid('position')"
        [isDisabled]="contactForm.get('dropdown')?.value !== '1'"
        [errorText]="contactForm.get('position').errors?.alphabeticOnly ? rendering?.fields?.OnlyAlphabeticError?.value : 
        rendering?.fields?.FieldIsRequiredError?.value"
      >
      </div>
      <div 
        app-form-text-input
        formControlName="email"
        [name]="'email'"
        [id]="'email'"
        [labelText]="rendering.fields?.EmailLabel?.value"
        [isRequired]="true"
        [error]="isFieldInvalid('email')"
        [errorText]="contactForm.get('email').errors?.email ? rendering?.fields?.EmailError?.value : rendering?.fields?.FieldIsRequiredError?.value"
      >
      </div>
      <div 
        app-form-text-input
        formControlName="telephone"
        [name]="'telephone'"
        [id]="'telephone'"
        [labelText]="rendering.fields?.TelephoneNumberLabel?.value"
        [isRequired]="false"
        [error]="isFieldInvalid('telephone')"
        [mask]="{ mask: '+00 0000000000' }"
        [errorText]="rendering?.fields?.TelephoneDigitsError?.value"
      >
      </div>
      <div formGroupName="products">
        <div class="eq-text-body-sm-m lg:eq-text-body-sm eq-text-blue-darkBlue eq-mb-4 eq-font-bold">{{rendering?.fields?.MultipleCheckboxLabel?.value}}</div>
        <ng-container *ngFor="let item of rendering?.fields?.MultipleCheckboxItems; let i = index;">
          <div
          app-form-checkbox
          [formControlName]="item.fields?.Value?.value"
          [isRequired]="false"
          [name]="item.fields?.Value?.value"
          [id]="item.fields?.Value?.value"
          [labelTextRight]="item.fields?.Text?.value"
          (change)="changeSelectedCategories()"
        >
        </div>
        </ng-container>
      </div>
      <!-- TODO check height -->

      <div 
        app-form-text-area
        formControlName="message"
        [name]="'message'"
        [id]="'message'"
        [helperText]="rendering?.fields?.MessageHelperText?.value"
        [labelText]="rendering.fields?.MessageLabel?.value"
        [maxLength]="+rendering?.fields?.MessageCharLength?.value>0 ? 500 : 500"
        [placeholder]="rendering.fields?.MessagePlaceholder?.value"
        [isRequired]="false"
        [error]="isFieldInvalid('message')"
        [errorText]="rendering?.fields?.OnlyAlphabeticError?.value"
        class="eq-h-full lg:eq-h-[70%]"
      > 
      </div>
      <div class="eq-flex eq-items-center lg:eq-justify-center lg:eq-col-span-2 lg:eq-mx-auto lg:eq-w-[523px]">
        <div app-form-checkbox 
          formControlName="termsCheckbox"  
          [isRequired]="true"
          [name]="'termsCheckbox'" 
          [id]="'termsCheckbox'"
          [error]="isFieldInvalid('termsCheckbox')"
          [errorText]="rendering?.fields?.TermsAndConditionsError?.value"
          [isChecked]="contactForm.get('termsCheckbox').value"
          [labelRichText]="rendering.fields.TermsRichText"
        >
        </div>
      </div>

      <div class="lg:eq-col-span-2 eq-flex eq-flex-col-reverse eq-gap-5 lg:eq-flex-row lg:eq-justify-center lg:eq-items-center lg:eq-gap-[60px]">
        <button (click)="clearForm()" type="button" class="eq-btn eq-btn-secondary">{{rendering.fields?.ClearButtonLabel?.value}}</button>
        <button type="submit" class="eq-btn eq-btn-primary" [disabled]="loading">{{rendering.fields?.SubmitButtonLabel?.value}}<i *ngIf="loading" class="eq-icons eq-icon-hourglass eq-animate-spin eq-ml-2"></i></button>
      </div>

     
    </form>
  </div>
  <div id="contactSumbitMessage">
    <div *ngIf="submissionResponse==='success'" class="eq-container md:eq-w-[710px] eq-p-6 eq-bg-white eq-animate-pulse" >
      <div class="eq-text-heading6-m lg:eq-text-heading6 eq-font-bold eq-mb-6 eq-text-blue-darkBlue">{{rendering?.fields?.SuccessTitle?.value}}</div>
      <p>{{rendering?.fields?.SuccessSubtitle?.value}}</p>
    </div>
    <div *ngIf="submissionResponse==='fail'" class="eq-container md:eq-w-[710px] eq-p-6 eq-bg-white eq-animate-pulse">
      <div class="eq-text-heading6-m lg:eq-text-heading6 eq-font-bold eq-mb-6 eq-text-red-brandRed">{{rendering?.fields?.ErrorTitle?.value}}</div>
      <p>{{rendering?.fields?.ErrorSubtitle?.value}}</p>
    </div>
  </div>
</section>
